import React from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Dashboard from './pages/dashboard/Dashboard';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Reset from './pages/auth/Reset';
import Navbar from './components/Navbar';
import AdminDashboard from './pages/admin/adminDashboard';
import AdminUserManagement from './pages/admin/AdminUserManagement';
import AdminOnlyRoute from './components/admin/adminOnlyRoute/AdminOnlyRoute';
import TaskList from './pages/TaskList'; 
import NotFound from './pages/notFound/NotFound';
import Contact from "./pages/contact/Contact";
import { ToastContainer } from "react-toastify";
import Footer  from './components/footer/Footer';
import { useAuth } from './contexts/AuthContext';
import { selectIsLoggedIn } from './redux/slice/authSlice';
import Spinner from './components/loader/Loader'

// ---  PrivateRoute ---
const PrivateRoute = ({ children }) => {
  const { loading } = useAuth();
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (loading) {
    return null; 
  }
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

// --- PublicOnlyRoute ---
const PublicOnlyRoute = ({ children }) => {
  const { loading } = useAuth();
  const isLoggedIn = useSelector(selectIsLoggedIn);

  if (loading) {
    return <Spinner />; 
  }
  return isLoggedIn ? <Navigate to="/" replace /> : children;
};

const App = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
      <>
        <ToastContainer />
        <Navbar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/login" element={
            <PublicOnlyRoute>
              <Login />
            </PublicOnlyRoute>
          } />
          <Route path="/register" element={
            <PublicOnlyRoute>
              <Register />
            </PublicOnlyRoute>
          } />
          <Route path="/forgot-password" element={<Reset />} />
          <Route path="/contact" element={<Contact />} />

          {/* Protected routes */}
          <Route path="/tasks" element={
            <PrivateRoute>
              <TaskList /> 
            </PrivateRoute>
          } />

         {/* Admin-specific protected routes */}
           <Route path="/admin" element={
            <PrivateRoute>
              <AdminOnlyRoute>
                <AdminDashboard />
              </AdminOnlyRoute>
            </PrivateRoute>
          }>
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users" element={<AdminUserManagement />} />
            <Route path="tasks" element={<TaskList />} /> 
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>

        {!isAdminRoute && <Footer />}
      </>
  );
};

export default App;
